export default __webpack_public_path__ + "static/media/sign.9bf0bd90.png";